module.exports = __webpack_public_path__ + "static/media/gameover_pic.ec49443f.png";